// Members-only preview: a superadmin-only, cookie-backed toggle that re-obscures
// members-only cards with the same blurred treatment a non-member sees. The
// cookie is scoped to the parent domain so one flip applies across every rec
// league subdomain.

import {
  cookieDomainAttribute,
  cookieSecureAttribute,
} from "./cookieDomain.ts";

const COOKIE = "mo_preview";
const MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export function isMembersOnlyPreviewOn(): boolean {
  if (typeof document === "undefined") return false;
  return document.cookie.split("; ").some((c) => c === `${COOKIE}=1`);
}

export function setMembersOnlyPreview(on: boolean): void {
  if (typeof document === "undefined") return;
  const domainPart = cookieDomainAttribute();
  const securePart = cookieSecureAttribute();
  document.cookie = on
    ? `${COOKIE}=1; path=/${domainPart}; max-age=${MAX_AGE_SECONDS}; samesite=lax${securePart}`
    : `${COOKIE}=; path=/${domainPart}; max-age=0; samesite=lax${securePart}`;
}

// Coerce a members-only rec that the viewer can actually see (e.g. a superadmin)
// into the same shape a non-member would receive, so the existing paywalled
// rendering (blurred image + redacted title) takes over.
export function coercePreviewPaywalled<T>(rec: T): T {
  const r = rec as any;
  if (!r || r.cardType !== "public" || !r.members_only) return rec;
  return {
    ...r,
    cardType: "paywalled",
    preview_image_url: r.image_url ?? r.preview_image_url ?? null,
    public_title: r.preview_title || undefined,
  } as T;
}
